import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";

// components
import { SHOP_DATA, SHOP_SETTING_KEY, USER_KEY } from "../const";
import CustomButton from "../components/CustomButton";

// apollo-client
import { useMutation, useLazyQuery } from "@apollo/client";
import { USER_LOGIN_V2 } from "../apollo/login/login";
import { errorSwal } from "../helper/sweetalert";

// react-bootstrap
import { Card, Spinner, Form } from "react-bootstrap";

// icons
import { MdLogin } from "react-icons/md";
import { GET_SETTING_BY_SHOP, GET_SETTING_BY_SHOP_V2 } from "../apollo/setting_apollo/query";

// Validation schema using Yup
const validationSchema = Yup.object({
  username: Yup.string().required("ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້"),
  password: Yup.string().required("ກະລຸນາປ້ອນລະຫັດຜ່ານ"),
});

const ExpiredModal = ({ onClose }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "40px 30px",
          borderRadius: "12px",
          width: "450px",
          textAlign: "center",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <div style={{ fontSize: "50px", color: "#FF9800", marginBottom: "20px" }}>
          ❗
        </div>

        <h2
          style={{
            fontSize: "22px",
            fontWeight: "700",
            marginBottom: "10px",
            color: "#333",
            lineHeight: "1.5",
          }}
        >
          ບັນຊີຮ້ານຂອງທ່ານຫມົດເວລາການໃຊ້ງານແລ້ວ
        </h2>

        <p
          style={{
            fontSize: "15px",
            color: "#666",
            marginBottom: "30px",
            lineHeight: "1.6",
          }}
        >
          ກະລຸນາຕິດຕໍ່ຫາທີມງານດູແລລະບົບ ຫຼື ຄຣິກເຂົ້າ ເຕີມແພັກເກັດ ເພື່ອຕໍ່່ອາຍຸການໃຊ້ງານລະບົບ
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <button
            style={{
              background: "#0d6efd",
              color: "#fff",
              padding: "10px 25px",
              borderRadius: "8px",
              border: "none",
              fontSize: "16px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.open("https://www.bbbb.com.la/#pricing", "_blank", "noopener,noreferrer");
              onClose();
            }}
          >
            ເຕີມແພັກເກດ
          </button>

          <button
            style={{
              background: "#dc3545",
              color: "#fff",
              padding: "10px 25px",
              borderRadius: "8px",
              border: "none",
              fontSize: "16px",
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            ຍົກເລີກ
          </button>
        </div>
      </div>
    </div>
  );
};

function Login() {
  const history = useHistory();

  const [fetchSettingShop, { loading: loadingQuery }] = useLazyQuery(GET_SETTING_BY_SHOP_V2, { fetchPolicy: "cache-and-network" });

  const [userLogin, { loading: loadingLogin }] = useMutation(USER_LOGIN_V2, {
    onCompleted: async (data) => {
      if (data?.loginV2?.status) {
        localStorage.setItem(USER_KEY, JSON.stringify(data?.loginV2?.data));
        localStorage.setItem(SHOP_DATA, JSON.stringify(data?.loginV2?.data?.data?.shop));
        const setting = await fetchSettingShop({
          variables: {
            where: { shop: data?.loginV2?.data?.data?.shop?.id },
          },
        })
        // save to local storage
        if (setting?.data?.settingByShopIdV2) {
          await localStorage.setItem(SHOP_SETTING_KEY, JSON.stringify(setting?.data?.settingByShopIdV2));
        }
        
        const shopId = data?.loginV2?.data?.data?.shop?.id;
        const role = data?.loginV2?.data?.data?.role;
        
        if (shopId === "69a7e3eb629c3100136283dd" && role !== "ADMIN") {
          window.location.href = "/settings/production_tracking";
        } else {
          window.location.href = "/sale/limit/50/page/1";
        }
        return;
      }
      if (data?.loginV2?.msg === "subscription has expired" && data?.loginV2?.status === false) {
        openExpiredModal();
        return;
      }
      errorSwal(data?.loginV2?.msg || "ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານຂອງທ່ານບໍ່ຖືກຕ້ອງ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ");
    },
    onError: (error) => {
      console.log("Error in login v2", error);
      errorSwal("ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານຂອງທ່ານບໍ່ຖືກຕ້ອງ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ");
    }
  });

  // State to manage password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const closeExpiredModal = () => setShowExpiredModal(false);

  const openExpiredModal = () => {
    setShowExpiredModal(true);
  };


  const onLogin = async (data) => {
    try {
      if (loadingLogin || loadingQuery) return;

      await userLogin({
        variables: {
          data,
        },
      });

      // if (_dataRespond?.data?.login) {
      //   localStorage.setItem(USER_KEY, JSON.stringify(_dataRespond?.data?.login));
      //   localStorage.setItem(SHOP_DATA, JSON.stringify(_dataRespond?.data?.login?.data?.shop));
      //   const setting = await fetchSettingShop({
      //     variables: {
      //       where: { shop: _dataRespond?.data?.login?.data?.shop?.id },
      //     },
      //   })
      //   // save to local storage
      //   localStorage.setItem(SHOP_SETTING_KEY, JSON.stringify(setting?.data?.settingByShopId));
      //   history.push("/sale/limit/50/page/1");
      //   return;
      // }
    } catch (error) {
      errorSwal("ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານຂອງທ່ານບໍ່ຖືກຕ້ອງ ກະລຸນາລອງໃໝ່ອີກຄັ້ง");
    }
  };

  // const handleWhatsAppClick = () => {
  //   const phoneNumber = '+1234567890'; // Replace with the desired phone number
  //   const message = 'Hello, I would like to inquire about...'; // Optional custom message
  //   const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  //   window.open(url, '_blank');
  // };

  // // Function to handle Messenger click
  // const handleMessengerClick = () => {
  //   const facebookPageId = 'yourFacebookPageId'; // Replace with your Facebook page ID
  //   const url = `https://m.me/${facebookPageId}`;
  //   window.open(url, '_blank');
  // };

  return (
    <React.Fragment>
      <div className="login-main">
        
        <Card className="section-control-form" style={{ backgroundColor: '#fff', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
          <Card.Body>
            <div className="d-flex justify-content-center align-items-center flex-column">
          <h2 className="title-login-form">PackXi POS</h2>
          <p style={{ color: '#1F3A60', fontSize: 16 }}>ລະບົບຈັດການໜ້າຮ້ານ ຈາກ PackXi Co., Ltd</p>
        </div>
            <Formik
              initialValues={{
                username: "",
                password: "",
              }}
              validationSchema={validationSchema}
              onSubmit={onLogin}
            >
              {({ values, handleChange, handleSubmit, errors, touched }) => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group controlId="formUsername">
                    <Form.Label>ຊື່ຜູ້ໃຊ້</Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      value={values.username}
                      onChange={handleChange}
                      isInvalid={touched.username && !!errors.username}
                      placeholder="ປ້ອນຊື່ນຳໃຊ້..."
                      style={{ backgroundColor: '#f3f4f6', border: 'none', padding: '12px' }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.username}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="formPassword" className="mt-2">
                    <Form.Label>ລະຫັດຜ່ານ</Form.Label>
                    <Form.Control
                      type={showPassword ? "text" : "password"} // Toggle password visibility
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      isInvalid={touched.password && !!errors.password}
                      placeholder="******"
                      style={{ backgroundColor: '#f3f4f6', border: 'none', padding: '12px' }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* Show password checkbox */}
                  <Form.Group controlId="formShowPassword" className="my-4">
                    <Form.Check
                      type="checkbox"
                      label="ສະແດງລະຫັດຜ່ານ"
                      checked={showPassword}
                      onChange={() => setShowPassword(!showPassword)} // Toggle showPassword state
                    />
                  </Form.Group>

                  <CustomButton
                    title={loadingLogin ? "ກຳລັງເຂົ້າລະບົບ..." : "ລ໋ອກອິນ"}
                    borderRadius="8px"
                    padding={"1em 0"}
                    onClick={handleSubmit}
                    icon={loadingLogin ? <Spinner size="sm" /> : <MdLogin style={{ fontSize: 24 }} />}
                  />
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>

        {/* <br />
        <div className="d-flex gap-4 mt-4">
          <Button style={{ borderRadius: '50em', display: 'flex', gap:5, justifyContent: 'center', alignItems: 'center' }} variant="light">
            <FontAwesomeIcon icon={faWhatsapp} fontSize={28} /> WhatsApp
          </Button>
          <Button style={{ borderRadius: '50em', display: 'flex', gap:5, justifyContent: 'center', alignItems: 'center' }} variant="light">
            <FontAwesomeIcon icon={faFacebookMessenger} fontSize={28} /> Messenger
          </Button>
        </div> */}
      </div>
      {showExpiredModal && <ExpiredModal onClose={closeExpiredModal} />}
    </React.Fragment>
  );
}

export default Login;
